/**
 * Dashboard widgets — wired into `config.dashboard`.
 *
 * A single intro widget; the shared Dashboard shell owns the heading and subtitle.
 */

import type { WidgetConfig } from '#lib/apps/types.js';
import IntroWidget from '#lib/components/dashboard/IntroWidget.svelte';

export const widgets: WidgetConfig[] = [
	{
		id: 'summary',
		component: IntroWidget,
		props: { text: 'View traffic flow data for your network.' }
	}
];
